import SubscriptionStateApi from '@/api/SubscriptionStateApi';
import featureFlags from '@/api/featureFlag';
import moment from 'moment';

async function isDormantWinback() {
  // TODO: change the 0 to 3 when we remove the FF
  const MONTHS_UNTIL_WINBACK_EXPERIENCE = 0;
  const { isDormantWinback, since } = await SubscriptionStateApi.simplifiedSubscriptionState();
  const applicable = isDormantWinback && since < moment().subtract(MONTHS_UNTIL_WINBACK_EXPERIENCE, 'month').format();
  const featureFlagIsOff = (await featureFlags.getTreatment('dormant-winback')) === 'off';
  return applicable && !featureFlagIsOff;
}

export default isDormantWinback;
